export function formatSizeUnits(value: number) {
  if (value) {
    let data = '';
    if (value >= 1073741824) {
      data = `${(value / 1073741824).toFixed(2)} GB`;
    } else if (value >= 1048576) {
      data = `${(value / 1048576).toFixed(2)} MB`;
    } else if (value >= 1024) {
      data = `${(value / 1024).toFixed(2)} KB`;
    } else if (value > 1) {
      data = `${value} Byte`;
    } else if (value === 1) {
      data = `${value} Byte`;
    } else {
      data = '0 Byte';
    }
    return data;
  } else {
    return '0';
  }
}
